/**
 * Metadatos de los recursos de Cuentas por Pagar (Gastos, GastosContenedor, Pagos,
 * AnticiposProveedores) — mismo shape que `RESOURCES` de `config/resources.js`, pero
 * en archivo propio (no se toca `resources.js`, regla de la tarea: otros agentes
 * trabajan ahí en paralelo).
 *
 * Estas páginas NO usan `ResourcePage` genérico (acciones por fila que no soporta:
 * Cancelar, Aplicar Anticipo, líneas de pago seleccionables) — son bespoke en
 * `pages/finanzas-cxp/*`. Este archivo solo centraliza `route`/`title`/`recurso`
 * (para permisos `hasPermiso('recurso:accion')`) y evita repetir strings.
 */
export const RESOURCES_FINANZAS_CXP = {
  gastos: { route: 'gastos', title: 'Gastos', recurso: 'gastos' },
  'gastos-contenedor': { route: 'gastos-contenedor', title: 'Gastos de Contenedor', recurso: 'gastos-contenedor' },
  pagos: { route: 'pagos', title: 'Pagos a Proveedores', recurso: 'pagos' },
  'anticipos-proveedores': { route: 'anticipos-proveedores', title: 'Anticipos a Proveedores', recurso: 'anticipos-proveedores' },
};

export default RESOURCES_FINANZAS_CXP;
